import { get } from 'svelte/store';
import * as stores from '../stores/stores.js';

export function updateStores(data) {
    Object.entries(data).forEach(([key, value]) => {
      if (key in stores && typeof stores[key].set === 'function') {
        stores[key].set(value);
      }
    });
  }

export function getStoreValues() {
    return Object.fromEntries(
      Object.entries(stores).map(([key, store]) => {
        if (typeof store.subscribe === 'function') {
          return [key, get(store)];
        }
        return [key, store]; 
      })
    );
  }